import { useCallback } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { Button, Tooltip } from "@similarweb/ui-components";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { mnpNavigation, mnpTrademarkNavigation } from "../../../app/navigation";
import { useMonitorAndProtectCampaigns } from "../../../services/api/campaign";

import { TrademarkEmptyState } from "./empty-state-svg";

export const TrademarkDashboardEmpty = () => {
    const { translate } = useTranslate();
    const { data: campaignList = [] } = useMonitorAndProtectCampaigns({ includeDemoCampaigns: false });

    const handleGoToConfigCreate = useCallback(() => {
        void mnpTrademarkNavigation.trademarksCreate.go();
    }, []);

    const handleGoToCampaignCreate = useCallback(() => {
        void mnpNavigation.home.go();
    }, []);

    const haveCampaigns = campaignList.length > 0;

    return (
        <Stack
            paddingX="40px"
            paddingY="32px"
            gap="24px"
            alignItems="center"
        >
            <Stack
                paddingY="32px"
                gap="64px"
                alignItems="center"
            >
                <Text fontVariant="h2">
                    {translate("monitor_and_protect.features.trademark_config_list.trademark_violations_empty.title")}
                </Text>
                <TrademarkEmptyState />
                <Stack gap="8px">
                    <Tooltip
                        enabled={!haveCampaigns}
                        content={translate(
                            "monitor_and_protect.features.trademark_config_list.trademark_violations_empty.no_campaigns_tooltip",
                        )}
                    >
                        <Button
                            isDisabled={!haveCampaigns}
                            onClick={handleGoToConfigCreate}
                        >
                            {translate(
                                "monitor_and_protect.features.trademark_config_list.trademark_violations_empty.add_trademark_button",
                            )}
                        </Button>
                    </Tooltip>
                    {haveCampaigns ? null : (
                        <Button
                            type="flat"
                            onClick={handleGoToCampaignCreate}
                        >
                            {translate(
                                "monitor_and_protect.features.trademark_config_list.trademark_violations_empty.create_campaign_button",
                            )}
                        </Button>
                    )}
                </Stack>
            </Stack>
        </Stack>
    );
};
